export default "__VITE_ASSET__$iUbemSK__"